import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VENDOR_BIDS_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import VendorMyOfferBidTable from './components/VendorMyOfferBidTable';
import VendorOtherOfferBidTable from './components/VendorOtherOfferBidTable';

const VendorOfferBids = () => {
  const [activeTab, setActiveTab] = useState(VENDOR_BIDS_TABS.MY_OFFER);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[VENDOR_BIDS_TABS.MY_OFFER, VENDOR_BIDS_TABS.OTHER_OFFER]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab mb-3"
        />
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={VENDOR_BIDS_TABS.MY_OFFER}>
          {activeTab === VENDOR_BIDS_TABS.MY_OFFER && (
            <ErrorBoundary>
              <VendorMyOfferBidTable />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={VENDOR_BIDS_TABS.OTHER_OFFER}>
          {activeTab === VENDOR_BIDS_TABS.OTHER_OFFER && (
            <ErrorBoundary>
              <VendorOtherOfferBidTable />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default VendorOfferBids;
